import { Box, Collapse } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import SubMenuItem from './SubMenuItem';
const useStyles = makeStyles((theme) => ({
  submenu: {
    position: 'absolute',
    bottom: 1,
    left: 0,
    transform: 'translateY(100%)',
    width: '100%',
    zIndex: theme.zIndex.subMenuIndex,
    '&: ul': {
      color: 'red !important',
      '&:last-child': {
        borderBottom: 'none',
      },
    },
  },
}));
const SubMenuItemContainer = ({ children, show, subMenu }) => {
  const classes = useStyles();
  return (
    <Box className={classes.submenu}>
      <Collapse in={show}>
        <SubMenuItem
          title={subMenu.title}
          subMenuList={subMenu.subMenuList}
        ></SubMenuItem>
      </Collapse>
    </Box>
  );
};

SubMenuItemContainer.propTypes = {
  title: PropTypes.string,
  closeCallback: PropTypes.func,
  subMenuList: PropTypes.arrayOf(PropTypes.object),
};
export default SubMenuItemContainer;
